import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './HomePage.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import LocationReviewsData from './LocationReviewsData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';
import img22 from '../../Images/96.jpg'
import img23 from '../../Images/23.jpg'

export default function HomePage({ CitiePhone, locationsMain, CitiesData }) {

    const [Service, setService] = useState(true);
    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    const data = {
        title: "",
        rows: [
            {
                "title": "Why Choose AttiAir?",
                "content": "With years of experience and a passion for clean air, AttiAir delivers top-quality service backed by advanced equipment and expert technicians. We prioritize your comfort and safety by ensuring every project—big or small—is handled with care, transparency, and guaranteed satisfaction."
            },
            {
                "title": "What Services Do You Offer?",
                "content": "We offer a comprehensive range of services including air duct cleaning, dryer vent cleaning, HVAC repair, attic insulation, chimney and fireplace services, and roofing repairs. Whether it’s a home or business, AttiAir has you covered."
            },
            {
                "title": "How Much Do Your Services Cost?",
                "content": "Our pricing is competitive and transparent. Air duct cleaning starts at $99, dryer vent cleaning at $79, and all inspections are free. You’ll always know the cost before we begin any repairs or upgrades."
            },
            {
                "title": "Do You Offer Same-Day Service?",
                "content": "Yes! If your inspection reveals damage or buildup, we can often provide cleaning or repairs during the same visit. AttiAir is equipped for fast turnaround without sacrificing quality."
            },
            {
                "title": `Do You Provide Services In And Around ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}?`,
                "content": `Absolutely. AttiAir proudly serves ${CitiesData && CitiesData.City ? CitiesData.City : "your area"} and surrounding locations within a 75-mile radius. No matter where you’re located, our team is ready to help.`
            },
            {
                "title": "How Do I Book An Appointment?",
                "content": `It’s quick and easy! Call us directly at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or fill out our <a href='#book'>online booking form</a>. A friendly dispatcher will confirm your preferred time and walk you through the next steps.`
            },
            {
                "title": "How Often Should I Clean My Air Ducts?",
                "content": "We recommend cleaning every 3–5 years. However, if you’ve done renovations, have pets, or suffer from allergies, more frequent cleaning may be beneficial to maintain optimal indoor air quality."
            },
            {
                "title": "Why Is Dryer Vent Cleaning So Important?",
                "content": "Dryer vents collect lint and debris, which can lead to fire hazards and energy inefficiency. Cleaning your vents regularly improves safety, extends appliance life, and saves on utility bills."
            }
        ]
    };

    const styles = {
        bgColor: '#f3f3f3',
        titleTextColor: '#222222',
        titleTextSize: '18px',
        rowTitleColor: '#222222',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "AttiAir" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and AttiAir from title)(if no keywords just do for air duct) and body`
                const apiKey = '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'; // Replace with your actual API key
                const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}`,
                    },
                    body: JSON.stringify({
                        'model': 'gpt-3.5-turbo',
                        'messages': [
                            {
                                'role': 'user',
                                'content': searchKeyword
                            }
                        ]
                    })
                })
                const dataChat = await resChat.json()

                setResponse(JSON.parse(dataChat.choices[0].message.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="HomePage" id="homepage">
            <Helmet>
                {/* <!-- TITLE (Max 65 characters) --> */}
                <title>AttiAir | Air Duct, Chimney, HVAC, Roofing & Insulation Experts | 866-257-5796</title>

                {/* <!-- META TITLE (Max 35 characters) --> */}
                <meta name="title" property="title" content="AttiAir | Home Comfort Experts | 866-257-5796" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="AttiAir | Home Comfort Experts | 866-257-5796" data-react-helmet="true" />

                {/* <!-- META DETAILS --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.attiair.com/images/og-image.jpg" data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.attiair.com/" data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="ATTIAIR" data-react-helmet="true" />

                {/* <!-- META DESCRIPTION (Max 155 characters, First Letter Uppercase) --> */}
                <meta
                    name="description"
                    content="AttiAir Provides Expert Air Duct, Dryer Vent, Chimney, Roofing, HVAC, And Attic Insulation Services To Keep Your Home Safe, Efficient, And Comfortable."
                    data-react-helmet="true"
                />
                <meta
                    name="og:description"
                    property="og:description"
                    content="AttiAir Provides Expert Air Duct, Dryer Vent, Chimney, Roofing, HVAC, And Attic Insulation Services To Keep Your Home Safe, Efficient, And Comfortable."
                    data-react-helmet="true"
                />

                <meta name="og:site_name" property="og:site_name" content="AttiAir" data-react-helmet="true" />

                {/* <!-- KEYWORDS --> */}
                <meta
                    name="keywords"
                    content="Air Duct Cleaning, Chimney Repair, Dryer Vent Cleaning, Roofing Services, HVAC Repair, Attic Insulation, Fireplace Cleaning, Air Duct Inspection, Chimney Sweeping, Roof Replacement, Furnace Maintenance, Ventilation Services, Residential HVAC, Commercial Roofing, Home Energy Efficiency, Insulation Installation, Indoor Air Quality, Roof Leak Repair, Same-Day Service"
                    data-react-helmet="true"
                />
            </Helmet>

            <div className="HomePageMainBanner">
                <div className="HomePageMainBannerTopLine">
                    <div className="HomePageMainBannerTopLineLine"></div>
                    <div className="HomePageMainBannerTopLineDot"></div>
                    <h1>ATTIAIR</h1>
                </div>
                <div className="HomePageMainBannerTop">
                    <img src={require(`../../Images/air.jpg`)} />
                    <img src={require(`../../ImagesLogos/Logo1.png`)} className="bannerlogohere" />
                    <div className="HomePageMainBannerTopLEFT"></div>
                </div>
                <div className="HomePageMainBannerBottom">
                    <div className="HomePageMainBannerBottomLeft">
                        <h1>Home Services You Can Trust for Over 20 Years in {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"}</h1>
                        <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> and Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Local Experts in Air Duct, Roofing, HVAC, Chimney, Insulation & Dryer Vent Services</h2>
                        <div className="HomePageMainBannerBottomLeftBtns">
                            <a target='_blank' href={`tel:${CitiePhone}`}>Call Us Now</a>
                            <a target='_blank' href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                        </div>

                        <h4>YOUR LOCAL EXPERTS IN WHOLE-HOME COMFORT</h4>
                        <div className="HomePageMainBannerBottomLeftLine"></div>
                        <p>AttiAir offers a complete range of professional services to keep your home clean, safe, and energy efficient. With over two decades of experience, we specialize in:</p>
                        <br />
                        <ul>
                            <h5> <a href="/airduct">Air Duct Cleaning</a> </h5>Improve indoor air quality and HVAC efficiency by removing dust and allergens.
                            <h5> <a href="/dryer">Dryer Vent Cleaning</a> </h5>Prevent fire hazards and boost appliance performance with expert lint removal.
                            <h5> <a href="/chimney">Chimney Sweep & Repair</a> </h5>Ensure safe fireplace operation by removing creosote and fixing structural issues.
                            <h5> <a href="/roofing">Roofing Services</a> </h5>From leak repair to full replacements, we protect your home from the elements.
                            <h5> <a href="/hvac">HVAC Maintenance</a> </h5>Keep your heating and cooling systems running efficiently year-round.
                            <h5> <a href="/attic">Attic Insulation</a> </h5>Enhance energy savings and indoor comfort with upgraded thermal protection.
                        </ul>
                        <p>Our trained technicians use industry-leading tools and techniques to deliver reliable results on every service call. Wherever you are, AttiAir is your trusted partner for whole-home care.</p>
                        <div className="MainBannerLeftRatedMain">
                            <div className="Header2Location">
                                <img src={require(`../../Images/place.png`)} alt="" />
                                <h6>{CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}</h6>
                            </div>
                            <div className="MainBannerLeftRated">
                                <h3>Rated 4.9 on Google</h3>
                                <span>
                                    <h4>4.9</h4>
                                    <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="HomePageMainBannerBottomRight">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                        <img src={require(`../../Images/banner55.jpeg`)} />
                        <h3><img src={require(`../../Images/stars.png`)} alt="Locally Owned & Operated AttiAir Chimney Sweep Repair" />Locally Owned & Operated</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Licensed | Bonded | Insured AttiAir Chimney Sweep Repair" />Certified | Licensed | Insured</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Satisfaction Guaranteed AttiAir Chimney Sweep Repair" />Satisfaction Guaranteed</h3>
                    </div>
                </div>
            </div>
            {/* HomePageGoodBY */}
            <div className="HomePageGoodBY">
                <h1>SAY GOODBYE TO HOME MAINTENANCE WORRIES</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>AttiAir provides complete solutions for air quality, structural integrity, and energy savings.</h2>
                <div className="HomePageGoodBYList">
                    <img src={require(`../../Images/chimneyrepair.jpg`)} />
                    <img src={require(`../../Images/112.jpg`)} />
                    <img src={require(`../../Images/hvac.webp`)} />
                    <img src={require(`../../Images/12.jpg`)} />
                </div>
            </div>
            {/* HomePageReviews */}
            <div className="HomePageReviews">
                <div className="HomePageReviewsHeader">
                    <h2>Service Reviews from Real Customers:</h2>
                    <h1>Trusted by Homeowners Across the U.S.</h1>
                    <div className="HomePageReviewsHeaderLine"></div>
                </div>
                <div className="HomePageReviewsMenu">
                    {LocationReviewsData.map((A, index) =>
                        <div key={index} className="HomePageReviewsMenuBox">
                            <div className="HomePageReviewsMenuBoxStars">
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                            </div>
                            <h1>{A.review}</h1>
                            <h2>{A.customer}</h2>
                        </div>
                    )}
                </div>
            </div>

            {/* MainBanner2Top2 */}
            <div className="HomePageServices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <h3>AIR DUCT CLEANING</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/ductrepair.png`)} alt="Air Duct Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Enhance indoor air quality with AttiAir’s expert air duct cleaning. Over time, dust, pet dander, and allergens accumulate in your ducts, compromising the air you breathe. Our advanced cleaning process removes contaminants, boosts HVAC efficiency, and promotes a healthier home. Whether you're tackling allergies or simply improving airflow, we've got you covered. Trust AttiAir for cleaner air—schedule your service today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Allergen & Dust Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duct Sanitization</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Mold & Mildew Treatment</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Air Quality Enhancement</h2>
                                <a href="/airduct">Explore This Service</a>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>CHIMNEY REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/chimnneyinspection.webp`)} alt="Chimney Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Cracked masonry, damaged caps, and leaks can put your home at risk. AttiAir’s chimney repair services restore safety, performance, and curb appeal. Our expert technicians fix structural issues, repair crowns, and seal water-damaged areas to prevent future hazards. Keep your home protected—book your chimney repair today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Chimney Crown Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Masonry Crack Sealing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Water Leak Protection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Chimney Cap & Flashing Repair</h2>
                                <a href="/chimney">Explore This Service</a>
                            </div>
                        </div>
                    </a>


                    <a className="MainBanner2TopBoxBox">
                        <h3>DRYER VENT CLEANING</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/dryerrepair.jpg`)} alt="Dryer Vent Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Clogged dryer vents are a leading cause of house fires and can spike your energy bills. AttiAir’s professional dryer vent cleaning service removes lint buildup, improves airflow, and helps your dryer run safely and efficiently. Protect your home and extend the life of your appliance—schedule your cleaning today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Lint & Debris Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Improved Dryer Efficiency</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Line Inspection & Cleaning</h2>
                                <a href="/dryer">Explore This Service</a>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>ROOFING SERVICES</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/111.jpg`)} alt="Roofing Services" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Leaks, damaged shingles, or worn-out materials can compromise your home's safety. AttiAir’s roofing experts provide reliable repairs, replacements, and inspections to keep your roof in top condition. Whether you're dealing with storm damage or old age, we deliver lasting solutions to protect your home and investment.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Roof Leak Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Shingle & Tile Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Full Roof Inspections</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Flat & Sloped Roofing Solutions</h2>
                                <a href="/roofing">Explore This Service</a>
                            </div>
                        </div>
                    </a>


                    <a className="MainBanner2TopBoxBox">
                        <h3>HVAC SERVICES</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/hvac.jpg`)} alt="HVAC Services" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Is your home too hot or too cold? AttiAir’s HVAC services keep your heating and cooling systems running smoothly year-round. From repairs and tune-ups to full system installations, we deliver comfort, efficiency, and energy savings with every visit. Stay in control of your indoor climate—book an HVAC service today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />AC & Heating Repairs</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Seasonal Tune-Ups</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />System Installation & Upgrades</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Thermostat & Airflow Optimization</h2>
                                <a href="/hvac">Explore This Service</a>
                            </div>
                        </div>
                    </a>


                    <a className="MainBanner2TopBoxBox">
                        <h3>ATTIC INSULATION</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/attic.jpeg`)} alt="Attic Insulation" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Poor insulation in your attic leads to higher energy bills and uneven indoor temperatures. AttiAir’s attic insulation services help regulate your home’s climate, reduce energy loss, and boost overall comfort. From blown-in to batt insulation, we use top-grade materials for long-term savings and efficiency.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Blown-In Insulation Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Batt Insulation Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Energy Efficiency Upgrades</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Temperature & Moisture Control</h2>
                                <a href="/attic">Explore This Service</a>
                            </div>
                        </div>
                    </a>


                </div>
            </div>
            {/* HomePageBook */}
            <div className="HomePageBook" id="book">
                <div className="HomePageReviewsHeader">
                    <h2>Easy & Convenient Booking:</h2>
                    <h1>Schedule Your Service Online!</h1>
                    <div className="HomePageReviewsHeaderLine"></div>
                </div>
                <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            </div>

            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At AttiAir, we are dedicated to providing exceptional service to our community. For over 22 years, we have committed ourselves to delivering top-quality air duct cleaning services over {CitiesData && CitiesData.City ? CitiesData.City : ""}, ensuring healthier and more comfortable living environments. In addition to air duct cleaning, we also offer a range of services tailored to improve indoor air quality and meet the unique needs of our valued customers.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me AttiAir" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
        </div>
    )
}

